import { createReducer, INITIAL_STATE } from '@shared/redux';
import { isSameRule } from './rules.utils';
import { FilterRule } from './rules.types';

export const APPLY_RULE = '@campaigns/campaigns-filters/rules/APPLY_RULE';
export const REMOVE_RULE = '@campaigns/campaigns-filters/rules/REMOVE_RULE';
export const CLEAR_RULES = '@campaigns/campaigns-filters/rules/CLEAR_RULES';

export const SET_CUSTOM_FILTER_RULES = '@campaigns/campaigns-filters/rules/SET_CUSTOM_FILTER_RULES';

export const getCampaignsFilterRules = state => state.campaigns.campaignsFilters.rules;
export const getCampaignsFilterRulesCount = state => getCampaignsFilterRules(state).length;

export const applyRules = rules => ({
    type: APPLY_RULE,
    payload: { rules },
});

export const removeRule = ({ field, operator, value }: FilterRule) => ({
    type: REMOVE_RULE,
    payload: {
        field,
        operator,
        value,
    },
});

export const clearRules = () => ({
    type: CLEAR_RULES,
    payload: {},
});

export const setCustomFilterRules = (rules = []) => ({
    type: SET_CUSTOM_FILTER_RULES,
    payload: rules,
});

const initialState = [];

export const rulesReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [APPLY_RULE]: (_, action) => [...action.payload.rules],
    [REMOVE_RULE]: (state, action) => state.filter(
        rule => !isSameRule(rule, action.payload),
    ),
    [CLEAR_RULES]: () => initialState,
    [SET_CUSTOM_FILTER_RULES]: (_, action) => [...action.payload],
});
